export default __webpack_public_path__ + "static/media/CEO.6263a818.jpg";